module.exports = __webpack_public_path__ + "img/f685e3a.png";